function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import * as React from 'react';
import Qs from 'qs';
import { StyleSheet, View, ActivityIndicator } from 'react-native';
import wrapComponent from "../../core/wrapComponent";
const config = {
  html: `
  <html>
  <body>
      <div id="content" style="display: none"></div>
  </body>
  <script>
      const source = new URLSearchParams(window.location.search);` + 'let html = `<form method=\'POST\' action=\'${source.get(\'uri\')}\'>`;' + '      const params = JSON.parse(source.get(\'body\'));' + 'Object.entries(params).forEach(([name, value]) => (html += `<input name="${name}" value="${value}" />`));' + `      html +=
        "<input id='submit' type='submit' />" +
        "</form>";
      const div = document.createElement('div');
      div.innerHTML = html;
      document.getElementById('content').appendChild(div);
      document.getElementById('submit').click();
  </script>
  </html>
  `
};

class WebViewElement extends React.Component {
  constructor(_props) {
    super(_props);

    _defineProperty(this, "state", {
      html: null
    });

    _defineProperty(this, "source", {});

    _defineProperty(this, "updateSource", props => {
      if (props.uri) {
        if (!props.source.uri) {
          this.source = {
            uri: props.uri
          };
        }
      }

      if (props.html) {
        if (!props.source.html) {
          this.source = {
            html: props.html
          };
        }
      }
    });

    _defineProperty(this, "setRef", ref => this.frameRef = ref);

    _defineProperty(this, "handleSource", (source, newWindow) => {
      if (!source.method) return;

      if (newWindow) {
        this.handleSourceInNewWindow(source, newWindow);
      } else {
        this.handleSourceInIFrame(source);
      }
    });

    _defineProperty(this, "handleSourceInIFrame", source => {
      const {
        uri
      } = source,
            options = _objectWithoutProperties(source, ["uri"]);

      const baseUrl = uri.substr(0, uri.lastIndexOf('/') + 1);
      fetch(uri, options).then(response => response.text()).then(html => this.setState({
        html: `<base href="${baseUrl}" />${html}`
      }));
    });

    _defineProperty(this, "handleSourceInNewWindow", (source, newWindow) => {
      if (source.method === 'POST') {
        var _newWindow$name, _newWindow$features;

        const contentType = source.headers['Content-Type'];
        let body = '';

        if (contentType && contentType.includes('application/x-www-form-urlencoded')) {
          body = Qs.parse(source.body);
        } else {
          console.warn('[WebView] When opening a new window, this content-type is not supported yet, please make a PR!', contentType);
          return;
        }

        window.open(`${config.html}?${Qs.stringify({
          uri: source.uri,
          body: JSON.stringify(body)
        })}`, (_newWindow$name = newWindow.name) !== null && _newWindow$name !== void 0 ? _newWindow$name : 'webview', (_newWindow$features = newWindow.features) !== null && _newWindow$features !== void 0 ? _newWindow$features : undefined);
      } else {
        console.warn('[WebView] When opening a new window, this method is not supported yet, please make a PR!', source.method);
      }
    });

    _defineProperty(this, "onMessage", nativeEvent => this.props.onMessage({
      nativeEvent
    }));

    _defineProperty(this, "postMessage", (message, origin) => {
      this.frameRef.contentWindow.postMessage(message, origin);
    });

    _defineProperty(this, "handleInjectedJavaScript", html => {
      if (this.props.injectedJavaScript) {
        if (html) {
          return html.replace('</body>', `<script>${this.props.injectedJavaScript}</script></body>`);
        }

        return html;
      }

      return html;
    });

    this.updateSource(_props);
    this.handleSource(_props.source, _props.newWindow);
  }

  componentDidMount() {
    if (this.props.onMessage) {
      window.addEventListener('message', this.onMessage, true);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.source.uri !== nextProps.source.uri || this.props.source.method !== nextProps.source.method || this.props.source.body !== nextProps.source.body) {
      this.updateSource(nextProps);
      this.handleSource(this.source, nextProps.newWindow);
    }
  }

  componentWillUnmount() {
    if (this.props.onMessage) {
      window.removeEventListener('message', this.onMessage, true);
    }
  }

  render() {
    var _this$state$html;

    if (this.props.newWindow) {
      return /*#__PURE__*/React.createElement(View, {
        style: styles.loadingContainer
      }, /*#__PURE__*/React.createElement(ActivityIndicator, null));
    }

    const {
      title,
      onLoad,
      scrollEnabled
    } = this.props;
    const {
      source
    } = this;
    const styleObj = StyleSheet.flatten(this.props.style);
    return /*#__PURE__*/React.createElement('iframe', {
      title,
      ref: this.setRef,
      src: !source.method ? source.uri : undefined,
      srcDoc: this.handleInjectedJavaScript((_this$state$html = this.state.html) !== null && _this$state$html !== void 0 ? _this$state$html : source.html),
      width: styleObj && styleObj.width,
      height: styleObj && styleObj.height,
      style: [styles.iframe, scrollEnabled && styles.noScroll],
      allowFullScreen: true,
      allowpaymentrequest: 'true',
      frameBorder: '0',
      seamless: true,
      onLoad
    });
  }

}

_defineProperty(WebViewElement, "defaultProps", {
  scrollEnabled: true,
  source: {}
});

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  iframe: {
    width: '100%',
    height: '100%',
    borderWidth: 0
  },
  noScroll: {
    overflow: 'hidden'
  }
});
export default wrapComponent(WebViewElement, {});